import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { scheduleApi, scheduleKeys } from "@/features/schedule/api";
import type { QueryParams } from "@/lib/api/client";

export function useRoster(from: string, to: string) {
  return useQuery({
    queryKey: scheduleKeys.roster(from, to),
    queryFn: () => scheduleApi.roster(from, to),
  });
}

export function useAssignments(filters: QueryParams) {
  return useQuery({
    queryKey: scheduleKeys.assignments(filters),
    queryFn: () => scheduleApi.assignments(filters),
  });
}

export function useMyAssignments() {
  return useQuery({ queryKey: scheduleKeys.mine(), queryFn: scheduleApi.myAssignments });
}

function useScheduleMutation<TArgs, TResult>(fn: (args: TArgs) => Promise<TResult>) {
  const queryClient = useQueryClient();
  return useMutation<TResult, Error, TArgs>({
    mutationFn: fn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: scheduleKeys.all });
    },
  });
}

export function useCreateAssignment() {
  return useScheduleMutation(scheduleApi.createAssignment);
}

export function useCancelAssignment() {
  return useScheduleMutation((id: string) => scheduleApi.cancelAssignment(id));
}
